import { useReveal } from "../../hooks/useReveal";
import { Star, ExternalLink } from "lucide-react";

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?client=ms-android-google&hs=2ylp&sca_esv=6dd148a2df4a2bfc&sxsrf=ANbL-n7-YvCngh9fvFqrrhZOWiQJ3nucqQ:1777115942148&q=recensioni+di+manuel+faustini+cfa+calcinate&uds=ALYpb_ncDc7jTlmw6Mmq7NjuX5c-mIW9zKYuBZgSF7Oer-VlP_3O8XjOD98uoPrhpvNa9piCM18GnKxcg7kJFiEXLGkWdjl9cPLH0s7MI-teQ9rvjPq8RCQvzUxJPaA6o1BJVl1_kFRzcV0DL_xlIqxQ4K_7bcYnwdNQJTeZ_cQPwphvkt96WFLU_ukFzY7ZFEIanCgzuTM8&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOX-fG1QVhFGc8ccFDk96hTAHgrbLPpr8Y-8u5qOzfHms3YtOvWpmRMGUrIO--OaASNSGvVs8RJ6kDhp_EDW5jJhtw0925nITIgnVE4KleyLTxRzkSt1ANXb7e-HblZlDw65_hm8%3D&sa=X&sqi=2&ved=2ahUKEwj5-tLj8IiUAxUO-QIHHcTyCGsQxKsJKAJ6BAgWEAE&ictx=1&stq=1&cs=1&lei=JqPsafnPCI7yi-gPxOWj2AY";

const results = [
  "https://customer-assets.emergentagent.com/job_indie-finance-1/artifacts/euv3ixf1_QXBUILdv8UaEsk0G6TAorgQEPyMEky0mA9cQRSTW3vgHgWInOb.png",
  "https://customer-assets.emergentagent.com/job_indie-finance-1/artifacts/3h6hrw13_CZ1msc1i0MDByOb5T51wQlhxHsUVgEm47XgCIeHOkAnTVRp5u5.png",
  "https://customer-assets.emergentagent.com/job_indie-finance-1/artifacts/u3x3xclk_YFBL9o1DU2ZxMcEV875vAfvhb8MIl0uVRCvwlLj7gw0PhxS13N.png",
];

export const Risultati = () => {
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section
      id="risultati"
      data-testid="risultati-section"
      className="bg-[#F4F1EA] text-navy py-20 md:py-28 paper-grain"
    >
      <div className="container-editorial">
        <div ref={r1} className="reveal max-w-3xl mb-14">
          <p className="overline mb-6">Risultati</p>
          <h2 data-testid="risultati-title" className="display-2">
            Casi reali.<br />
            <em className="italic text-gold">Persone reali.</em>
          </h2>
          <p className="lede mt-8 max-w-2xl">
            Ogni cliente ha una storia diversa. Qui alcuni interventi recenti — nomi e
            strategie tutelati dal segreto professionale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {results.map((src, i) => (
            <figure
              key={i}
              data-testid={`result-${i}`}
              className="bg-white border border-line overflow-hidden"
            >
              <img
                src={src}
                alt={`Situazione portafoglio cliente ${i + 1}`}
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </figure>
          ))}
        </div>

        <div
          ref={r2}
          className="reveal mt-16 md:mt-20 border-t border-line pt-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-center"
        >
          <div className="md:col-span-7">
            <div className="flex items-center gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} className="fill-gold text-gold" />
              ))}
              <span className="ml-3 text-xs tracking-[0.22em] uppercase text-muteText">
                Le voci dei clienti
              </span>
            </div>
            <h3 className="display-3 max-w-xl">
              Le recensioni complete sono su <em className="italic text-gold">Google</em>.
            </h3>
            <p className="lede mt-5 max-w-xl">
              Trasparenza totale: ogni recensione è verificata e pubblicata
              direttamente dai clienti sul mio profilo Google Business.
            </p>
          </div>
          <div className="md:col-span-5 md:text-right">
            <a
              data-testid="google-reviews-link"
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Leggi le recensioni Google <ExternalLink size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
